<script>
  import { onMount, onDestroy } from 'svelte'
  import { push, replace } from 'svelte-spa-router'
  import { clientStore, userStore, peopleStore, locationStore } from '../../state/store'
  import { language, formatI18nDate, t } from '../../i18n/i18n'
  import { isUserAdmin, getName } from './../../helpers/utils.js'
  import Spinner from '../../components/Spinner.svelte'
  import { getLocationData, getPeopleData } from '../../state/actions'

  //Gets named parameters from Router
  export let params = {}

  import ViewContainer from '../../components/ViewContainer.svelte'
  import PeopleHeader from './People.header.svelte'
  import Breadcrumbs from '../../components/Breadcrumbs.svelte';

  // Location Id from url
  $: person = ''
  let promise
  let usersLocations = []
  let unsubLocation
  let unsubPeople

  onMount(() => {
    if (!isUserAdmin($userStore)) { replace('/') }
    promise = Promise.all([getPeopleData(), getLocationData()])
    unsubPeople = peopleStore.subscribe((p => {
      person = p.find(person => person._id === params.id)
    }))
    unsubLocation = locationStore.subscribe((locations) => {
      usersLocations = locations.filter(location => location.assignee === person._id)
    })
  })

  onDestroy(() => {
    unsubLocation()
    unsubPeople()
  })

</script>

{#await promise}
  <Spinner />
{:then}
    <ViewContainer>
      {#if person}
        <Breadcrumbs current={person.name}></Breadcrumbs>
      <section class="g-detail-page">
        <PeopleHeader {person} />
        <div>
          <h2>{$t['Assigned Locations']}</h2>
          <article class="g-card-list-wrapper">
            {#if usersLocations.length === 0}
              <div>
                <p>{$t.no_locations_assigned}</p>
              </div>
            {:else}
            {#each usersLocations as data, index}
              <ul on:click={() => push(`/locations/${data._id}`)} class='g-card-list'>
                {#each Object.entries(data) as [key, val]}
                  {#if 
                    key !== '_id' &&
                    key !== '__v' &&
                    key !== 'tenant' &&
                    key !== 'assignee' &&
                    key !== 'client' &&
                    key !== 'last_serviced' &&
                    key !== 'description' &&
                    key !== 'coordinates'
                  }
                    <li>
                      <p>{$t[key]}</p>
                      <p>{val}</p>
                    </li>
                  {/if}
                  {#if key === 'client'}
                    <li>
                      <p>{$t[key]}</p>
                      <p>{getName($clientStore, val)}</p>
                    </li>
                  {/if}
                  {#if key === 'last_serviced'}
                    <li>
                      <p>{$t[key]}</p>
                      <p>{formatI18nDate($language, val)}</p>
                    </li>
                  {/if}
                {/each}
              </ul>
            {/each}
          {/if}
          </article>
        </div>
      </section>
      {/if}
    </ViewContainer>
{/await}
